/**
 * @generated SignedSource<<0920a54abdb00dfc590dddf7077e11e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserSkillsEditDialog_User$data = {
  readonly id: string;
  readonly profile: {
    readonly industry: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
  readonly userSkills: ReadonlyArray<{
    readonly experience: number | null | undefined;
    readonly skill: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  }> | null | undefined;
  readonly " $fragmentType": "UserSkillsEditDialog_User";
};
export type UserSkillsEditDialog_User$key = {
  readonly " $data"?: UserSkillsEditDialog_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserSkillsEditDialog_User">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserSkillsEditDialog_User",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Industry",
          "kind": "LinkedField",
          "name": "industry",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserSkill",
      "kind": "LinkedField",
      "name": "userSkills",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "experience",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Skill",
          "kind": "LinkedField",
          "name": "skill",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "ed8f39ae09155d3ea980aae289b69ca1";

export default node;
